module.exports = __webpack_public_path__ + "img/loading.64ee8686.svg";